import OrderMFlexQRIconWithTooltipInfo from './IconWithTooltipInfo';
import OrderMFlexQRInfo from './Info';

const OrderMFlexQRComponents = {
  IconWithTooltipInfo: OrderMFlexQRIconWithTooltipInfo,
  Info: OrderMFlexQRInfo,
};

export default OrderMFlexQRComponents;
